import retry from '@blockcatio/tabby-library/lib/utilities/retry';

import { NETWORK_NAMES } from '../constants';
import { accountNetworkChange, accountNetworkChangeFailed } from '../actions/account';
import { ACCOUNT_WALLET_SELECT } from '../actionTypes';

export default ({ walletManager }) => ({ dispatch }) => (next) => {
  let lastNetwork;
  let nextNetwork;

  return async (action) => {
    next(action);

    if (action.type === ACCOUNT_WALLET_SELECT) {
      const wallet = walletManager.get(action.walletType, action.walletOptions.address);
      try {
        nextNetwork = await retry(() => wallet.getNetwork());
        if (nextNetwork !== lastNetwork) {
          const networkName = NETWORK_NAMES[nextNetwork] || NETWORK_NAMES.default;
          dispatch(accountNetworkChange(networkName));
        }
        lastNetwork = nextNetwork;
      } catch (error) {
        dispatch(accountNetworkChangeFailed(nextNetwork || ''));
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/middleware/updateNetwork.js